/** A small accessible loading spinner. `label` is announced to assistive
 *  tech and shown next to the spinner. */
export function Spinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div role="status" className="flex items-center gap-2 text-sm text-brand-slate">
      <span
        aria-hidden
        className="h-4 w-4 animate-spin rounded-full border-2 border-border border-t-brand-royal"
      />
      <span>{label}</span>
    </div>
  );
}
